import api from 'utils/apiClient';

export const getPlainRoles = () => {
  return api.get('/roles', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 1000,
    },
  });
};

export const getRoles = (params) => {
  return api.get('/roles', { params });
};

export const createRole = (data) => {
  return api.post('/roles', data);
};

export const editRole = (id, data) => {
  return api.patch(`/roles/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    notification: {
      visible: false,
    },
  });
};

export const deleteRole = (id) => {
  return api.delete(`/roles/${id}`);
};

export const bulkDeleteRoles = (ids) => {
  return api.delete(`/roles?items=${ids.join(',')}`);
};

export const getAdmins = (params) => {
  return api.get('/admins', { params });
};

export const createAdmin = (data) => {
  return api.post('/admins/create', data);
};

export const editAdmin = (data) => {
  return api.post('/admins/edit', data, {
    notification: {
      visible: false,
    },
  });
};

export const deleteAdmin = (id) => {
  return api.delete(`/admins/${id}`);
};

export const bulkDeleteAdmins = (ids) => {
  return api.delete(`/admins?items=${ids.join(',')}`);
};
